module.exports = __webpack_public_path__ + "media/video4.5c6890d1.mp4";